import { Manufacturer } from 'core/types/manufacturer';

export const SET_MANUFACTURERS = 'SET_MANUFACTURERS';

export class SetManufacturers {
  readonly type = SET_MANUFACTURERS;
  readonly payload: Manufacturer[];

  constructor(types: Manufacturer[]) {
    this.payload = types;
  }
}

export type Action = SetManufacturers;
